export default "__VITE_ASSET__CLLRMmOJ__"